import Vue from 'vue';
import Component from 'vue-class-component';
import PreviewImg from "../preview-dialog.vue";
import PreviewVideo from "../preview-video.vue";
import sizhenCaiji from "./sizhen-caiji.vue";
@Component({
  components:{
    PreviewImg,
    PreviewVideo,
    sizhenCaiji
  }
})
export class caijiMixin extends Vue {
  templateIndex: any = null
  c: any = {};
  cContent: any = {}; // 因为不能直接改动prop里面的数据，所以用Ccontent暂存下
  uid: any = ""; // 打开exe时生成的id
  previewUrl: any = '';
  ifShowPreview: any = false;
  ifShowPreviewVideo: any = false;
  get ifCompose() {
    return this.$store.state.ifCompose;
  }
  get patient() {
    return this.$store.state.patient;
  }
  preview(url: any) {
    console.log('预览')
    // window.open(url);
    this.ifShowPreview = true;
    this.previewUrl = url
  }
  previewVideo(url: any) {
    this.ifShowPreviewVideo = true;
    this.previewUrl = url
  }
  closePreview() {
    this.ifShowPreview = false;
    this.ifShowPreviewVideo = false;
  }
  openTip() {
    this.$message.warning("请先点击编辑按钮进入编辑模式");
  }

  
  updateData(e: any) {
    this.c = e;
    this.$emit("update", this.c);
  }
  updateContent(e: any) {
    this.cContent = e;
    this.$emit("updateContent", this.cContent);
  }
  save() {
    this.$emit("save");
  }


  startFenxi() {
    this.$emit("save");
  }
  /**
   *  @description 删除一张图片或者视频
   */
  delOne(key: any, index: any) {
    this.c.value[key].splice(index, 1);
    this.$forceUpdate();
    this.$emit("update", this.c);
  }
  // 修改当前题目数据
  change() {
    this.$forceUpdate();
    this.$emit("update", this.c);
  }
  // 修改整个content数据
  changeContent() {
    this.$forceUpdate();
    this.$emit("updateContent", this.cContent);
  }
  changeTaiContent(e: any) {
    const index: any = e.findIndex((val: any) => {
      return val == '无苔'
    })
    if (index != -1) {
      this.cContent.report['舌象信息']['苔色'] = [[], []]
    }
    this.changeContent();
  }
}